/**
 * BLSTC — StickyBuyButton mobile UX fix
 * Shows the sticky bar as soon as the main "Add to Cart" button
 * scrolls above the viewport, instead of waiting until the entire
 * product section has scrolled past the mid-screen point.
 */
(function () {
  function applyFix() {
    var StickyBuyButtonClass = customElements.get('sticky-buy-button');
    if (!StickyBuyButtonClass) return; // element not registered yet (shouldn't happen post-DMContentLoaded)

    StickyBuyButtonClass.prototype.handleScroll = function () {
      if (!this.isEnabled) return;

      var windowHeight = window.innerHeight;
      var footerRect = this.footer ? this.footer.getBoundingClientRect() : null;
      var isFooterInView = footerRect && footerRect.top < windowHeight && footerRect.bottom > 0;

      if (isFooterInView) {
        this.fadeOut();
        return;
      }

      // Resolve the main ATC element lazily (once per instance)
      if (!this._mainAtc) {
        this._mainAtc = this.section && this.section.querySelector('purchase-buttons');
      }

      if (this._mainAtc) {
        // Show sticky the moment purchase-buttons has scrolled above the viewport
        var atcRect = this._mainAtc.getBoundingClientRect();
        if (atcRect.bottom <= 0) {
          this.fadeIn();
        } else {
          this.fadeOut();
        }
      } else {
        // Fallback: original section-based logic
        var sectionRect = this.section.getBoundingClientRect();
        if (sectionRect.bottom <= windowHeight / 2) {
          this.fadeIn();
        } else {
          this.fadeOut();
        }
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix);
  } else {
    applyFix();
  }
})();
